import { Icon } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OfferAction from './OfferAction';

interface Props {
  onClick: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
}

const OfferRecalculateAction: React.FC<Props> = ({
  onClick,
  isLoading,
  isDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <OfferAction
      icon={<Icon name="GeneralActionsReset" />}
      onClick={onClick}
      isDisabled={isDisabled}
      isLoading={isLoading}
    >
      {t('SALES-CONVERSATION_OFFERS_SINLE-OFFER_ACTIONS_RECALCULATE')}
    </OfferAction>
  );
};

export default OfferRecalculateAction;
